import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React from "react";

const EmployeeAdvanceTab = ({
    selectedEmployee,
    setSelectedEmployee,
    employees,
    advanceAmount,
    setAdvanceAmount,
    advanceReason,
    setAdvanceReason,
}) => {
    return (
        <>
            <Autocomplete
                options={employees || []}
                getOptionLabel={(option) => option.employee_name || option.name}
                value={
                    employees?.find((emp) => emp.name === selectedEmployee) ||
                    null
                }
                onChange={(event, newValue) => {
                    setSelectedEmployee(newValue?.name || "");
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Employee"
                        variant="standard"
                        margin="normal"
                        required
                        fullWidth
                    />
                )}
                renderOption={(props, option) => (
                    <Box component="li" {...props}>
                        <Typography variant="body2">
                            {option.employee_name || option.name}
                        </Typography>
                    </Box>
                )}
            />
            <TextField
                label="Advance Amount"
                type="number"
                value={advanceAmount}
                onChange={(e) => setAdvanceAmount(e.target.value)}
                fullWidth
                margin="normal"
                variant="standard"
                inputProps={{ min: 0, step: 0.01 }}
                required
            />
            <TextField
                label="Purpose/Reason"
                value={advanceReason}
                onChange={(e) => setAdvanceReason(e.target.value)}
                fullWidth
                margin="normal"
                variant="standard"
                multiline
                rows={3}
                required
            />
        </>
    );
};

export default EmployeeAdvanceTab;
